






































































































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { FormState } from '@/components/prine/enums/FormState';
import DetailedConfirmModal from '@/components/prine/DetailedConfirmModal.vue';
import FormColorPicker from '@/components/form/FormColorPicker.vue';

import type { DynamicField } from '@/models/dynamicField';
import type { User } from '@/models/user';
import { dynamicFieldWebservice } from '@/webservices/dynamicField';
import type { CompanySetting } from '@/models/companySetting';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'StoreUpdateDynamicField',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {
        DetailedConfirmModal,
        FormColorPicker,
    },
})
export default class StoreUpdateDynamicField extends Vue {
    public FormState = FormState;

    // Data
    protected disabled: boolean = false;
    protected errorMsg: string = '';
    protected isConfirmModalActive: boolean = false;
    protected state: FormState = FormState.New;

    protected dynamicField: DynamicField = {} as DynamicField;
    protected loading = {
        data: false,
        color: '#fdc05d',
        size: '40px',
    };

    protected affectedData: Map<string, number> = new Map();

    @Getter('account/userInfo') private userInfo: User;
    @Getter('account/companySetting') private companySetting: CompanySetting;

    // Mounted is called initially
    private mounted() {
        if (this.$route.query.hasOwnProperty('dynamicFieldId')) {
            this.load(Number.parseInt(this.$route.query.dynamicFieldId.toString(), 10));
            this.state = FormState.Update;
        } else {
            this.dynamicField.order = 0;
        }
    }

    private load(dynamicFieldId: number) {
        this.loading.data = true;
        dynamicFieldWebservice.getById(dynamicFieldId).then((response) => {
            this.dynamicField = response.data;
            this.loading.data = false;
        });
    }

    private save() {
        this.disabled = true;
        const self = this;
        if (!this.validate()) {
            this.disabled = false;
            return 0;
        }

        if (this.state === FormState.New) {
            dynamicFieldWebservice
                .store(this.dynamicField)
                .then((response) => {
                    this.$buefy.toast.open({
                        duration: 3000,
                        message: this.$t('toastMessages.store.dynamicField').toString(),
                        type: 'is-success',
                    });
                    this.$router.push({ path: '/system/dynamicFields' });
                })
                .catch((error) => {
                    this.disabled = false;
                    console.log(error);
                });
        } else if (this.state === FormState.Update) {
            dynamicFieldWebservice
                .update(this.dynamicField)
                .then((response) => {
                    this.$buefy.toast.open({
                        duration: 3000,
                        message: this.$t('toastMessages.update.dynamicField').toString(),
                        type: 'is-success',
                    });
                    this.$router.push({ path: '/system/dynamicFields' });
                    this.disabled = false;
                })
                .catch((error) => {
                    this.disabled = false;
                    console.log(error);
                });
        }
    }

    private toggleConfirmModal(answer) {
        this.isConfirmModalActive = !this.isConfirmModalActive;
        if (answer === true) {
            this.remove();
        }
    }

    private remove() {
        const self = this;
        dynamicFieldWebservice
            .remove(this.dynamicField)
            .then((response) => {
                this.$buefy.toast.open({
                    duration: 3000,
                    message: this.$t('toastMessages.delete.dynamicField').toString(),
                    type: 'is-success',
                });
                this.$router.push({ path: '/system/dynamicFields' });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    private validate() {
        if (!this.dynamicField.title || this.dynamicField.title === '') {
            this.errorMsg = 'title';
            return 0;
        } else {
            return true;
        }
    }
}
